<template>
	<div class="banner relative" style="margin-bottom: 20px;">
		<div class="relative" style="width: 100%; height: 180px; background: rgb(125, 124, 124)">
			<img v-if="section.background_path" alt="" class="brightness-05 absolute h-full object-cover w-full" :src="$root.getImage(section.background_path)">
			<div class="header_banner mb-3 absolute ml-4 z-30">				
				<div class="flex flex-col items-center with-icon">
					<div class="flex justify-center items-center">
						<div class="w-6 mr-2 flex-shrink-0" v-if="section.icon_path"><img :src="$root.getImage(section.icon_path)" alt=""></div>
						<div class="font-semibold leading-tight truncate">{{ $root.getLangText(section.title) }}</div>
					</div>
					<div class="flex items-center gap-1 text-sm" style="line-height: 1.25rem !important;" v-if="!section.in_schedule && displayScheduleText(section)">
						<span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>
						<span v-html="displayScheduleText(section)"></span>
					</div>
				</div>
				
				<div class="with-out-icon my-5">
					<div class="section-title">{{ $root.getLangText(section.title) }}</div>
					<div class="flex items-center gap-1 text-sm" style="line-height: 1.25rem !important;" v-if="!section.in_schedule && displayScheduleText(section)">
						<span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>
						<span v-html="displayScheduleText(section)"></span>
					</div>
				</div>	

			</div>

			<div v-if="is_overlay" style="background: rgba(0, 0, 0, .5); position: absolute; width: 100%; height: 100%; top: 0; z-index: 1;"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'app_product_banner',
	
	props: ['section'],

	data() {
		return {
			is_overlay: false,
		}
	}
}
</script>